import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router";
import * as Sentry from "@sentry/react";
import "@fontsource/gothic-a1/400.css";
import "@fontsource/gothic-a1/500.css";
import "@fontsource/gothic-a1/600.css";
import "@fontsource/gothic-a1/700.css";
import "./globals.css";
import { App } from "./app";

// 오류 모니터링. 개발 중 오류가 운영 Sentry에 섞이지 않도록 빌드된(운영) 앱에서만 보낸다.
// DSN은 공개 값이다(브라우저 번들에 그대로 들어간다).
Sentry.init({
  dsn: "https://36ce22764b176cb49b1f7df351d1a6f1@o4512065474396160.ingest.us.sentry.io/4512065482981376",
  enabled: import.meta.env.PROD,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // 운영에서는 트래픽이 늘면 샘플링을 낮춘다. 리플레이는 텍스트·입력값이 기본으로 가려진다.
  tracesSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary
      fallback={
        <div className="flex flex-1 flex-col items-center justify-center gap-2 p-6 text-center">
          <h1 className="text-lg font-semibold">문제가 생겼어요</h1>
          <p className="text-sm text-muted-foreground">잠시 후 새로고침해 주세요. 계속되면 hello@dabarnote.unhub.kr로 알려주세요.</p>
        </div>
      }
    >
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
